import css from '../TicketCard/TicketCard.module.scss'
import React, { HTMLAttributes } from 'react'

import { useUrlCloudfront } from 'hooks/useEnv'

import { TicketCardBaseSkeleton } from '../TicketCard/Base'

type CardFlipItemProps = HTMLAttributes<HTMLDivElement> & {
  className?: string
  useLongCard: boolean
}

interface Props {
  useLongCard: boolean
}

const TicketCardSkeleton: React.FC<Props> = (props) => {
  const urlCloudfront = useUrlCloudfront()

  const { useLongCard } = props

  const CardFlipItem: React.FC<CardFlipItemProps> = (props) => {
    const { children, useLongCard } = props

    return (
      <div>
        <div
          className={css.walletTicketCardSkeleton}
          style={{
            backgroundImage: `url(${urlCloudfront}/images/wallet/ticket_grey${useLongCard ? '_long' : ''}.svg)`,
          }}
        >
          {React.Children.toArray(children)}
        </div>
      </div>
    )
  }

  return (
    <div className={css.walletTicketCard__flipCard}>
      <div className={css.walletTicketCard__flipCardInner}>
        <CardFlipItem useLongCard={useLongCard}>
          <TicketCardBaseSkeleton />
        </CardFlipItem>
      </div>
    </div>
  )
}

export default TicketCardSkeleton
